export default [
  {
    path: '/guide-tutorial/list',
    name: 'guide-tutorial-list',
    component: () => import('@/views/guide-tutorial/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Guide Tutorial List',
      breadcrumb: [{ title: 'Dashboard', url: '/dashboard' }, { title: 'Guide Tutorial' }, { title: 'Guide Tutorial List', active: true }],
      permissions: ['guide_tutorial_list']
    }
  }
]
